import React, { Fragment, useState, useEffect, useRef } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Link } from "react-router-dom";
import { Button, Dropdown, Modal, Form } from "react-bootstrap";
import { db, functions } from "../../../firebase";
import { httpsCallable } from "firebase/functions";
import Toast from "../toast/SetToast";
import { notifyError, notifyTopRight } from "../toast/SetToast";
import { useAuth } from "../../../context/AuthContext";
import { paymentPrivilages } from "../Booking/BookingUtils";
import { province } from "../Booking/BookingUtils";
/// images
import avartar5 from "../../../images/avatar/5.png";
import avartar1 from "../../../images/avatar/1.png";
import greenMark from "../../../images/avatar/green-check-mark.png";
import redMark from "../../../images/avatar/red-x.png";
import yellowMark from "../../../images/avatar/exclamation-mark.png";
import pause from "../../../images/avatar/pause.png";
import clock from "../../../images/avatar/clock.png";
import { createIncomingRecord, saveIncomingNote, saveIncomingFiles, updateIncomingRecord, deleteIncomingRecord, getIncomingNoteLocation, getVisibleIncomingFiles, removeIncomingFile } from "./incomingPatientRecords";
import IncomingFileUpload, { appendIncomingFiles } from "./IncomingFileUpload";
import IncomingFilePreview from "./IncomingFilePreview";
import { filterIncomingRecords, sortIncomingRecords, getIncomingCustomerOptions, buildIncomingExportRows, getIncomingAssignedDefaults } from "./incomingPatientFilters";
import { findIncomingPatientNameMatches, getIncomingPatientNameKeys } from "./incomingPatientNameMatches";
import * as XLSX from "xlsx";
import IncomingStudyDateInput from "./IncomingStudyDateInput";
import IncomingAvailabilityOverview from "./IncomingAvailabilityOverview";
import IncomingBirthDateInput from "./IncomingBirthDateInput";
import "./Incoming.css";
import { formatIncomingDate, formatIncomingCreatedAt } from "./incomingPatientDates";
import { getIncomingBookingPolicy, incomingBookingErrorMessage } from "./incomingBookingAvailability";
import {
  query,
  endAt,
  getDocs,
  collection,
  orderBy,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  startAt,
  getCountFromServer,
  doc,
  getDoc,
  where,
} from "firebase/firestore";
import swal from "sweetalert";
import { colors } from "@material-ui/core";
import { amber } from "@material-ui/core/colors";
import { select } from "@syncfusion/ej2-base";
import {
  isStaffCustomerScopedUser,
  filterCustomersForStaffNode,
  filterRecordsByStaffCustomerAccess,
} from "../../../utils/staffCustomerAccess";

const profileData = {
  hn: "",
  email: "",
  titleTh: "",
  firstnameTh: "",
  lastnameTh: "",
  nationalId: "",
  titleEn: "",
  firstnameEn: "",
  lastnameEn: "",
  dateOfBirth: "",
  sleepStudyDate: "",
  comorbidity: "",
  status: "Pending",
  ethnicity: "",
  nationality: "",
  religion: "",
  bloodType: "",
  note: "",
  gender: "",
  occupation: "",
  mobile: "",
  telephone: "",
  address1: "",
  address2: "",
  province: "",
  postcode: "",
  medicineIntolerance: "",
  healthInsurance: "",
  other: "",
  emergencyContact: "",
  relationship: "",
  emergencyContactPhone: "",
  refHn: "",
  refCustomer: "",
  nodeRef: "",
};

const statusList = ["Pending", "On Hold", "Appointed", "Cancel"];
const statusIcons = {
  Pending: clock,
  "On Hold": pause,
  Appointed: greenMark,
  Cancel: redMark,
};

const comorbidityOptions = [
  "ความดันโลหิตสูง",
  "หลอดเลือดสมอง",
  "หลอดเลือดหัวใจ",
  "โรคเบาหวาน",
  "โรคไขมันในเลือดสูง",
];

const IncomingComorbidityField = ({ id, defaultValue = "", onChange }) => {
  const parts = (defaultValue || "").split(",").map((part) => part.trim()).filter(Boolean);
  const [selected, setSelected] = useState(() => parts.filter((part) => comorbidityOptions.includes(part)));
  const [otherText, setOtherText] = useState(() => parts.filter((part) => !comorbidityOptions.includes(part)).join(", "));
  const [otherChecked, setOtherChecked] = useState(() => parts.some((part) => !comorbidityOptions.includes(part)));

  const update = (nextSelected, nextOtherChecked, nextOtherText) => {
    setSelected(nextSelected);
    setOtherChecked(nextOtherChecked);
    setOtherText(nextOtherText);
    onChange([...nextSelected, ...(nextOtherChecked && nextOtherText.trim() ? [nextOtherText.trim()] : [])].join(", "));
  };

  return (
    <fieldset className="form-group">
      <legend className="col-form-label">โรคร่วม</legend>
      {comorbidityOptions.map((option, index) => (
        <div className="form-check mb-2" key={option}>
          <input
            type="checkbox"
            className="form-check-input"
            id={`${id}-${index}`}
            checked={selected.includes(option)}
            onChange={(e) => update(e.target.checked ? [...selected, option] : selected.filter((value) => value !== option), otherChecked, otherText)}
          />
          <label className="form-check-label" htmlFor={`${id}-${index}`}>{option}</label>
        </div>
      ))}
      <div className="form-check mb-2">
        <input
          type="checkbox"
          className="form-check-input"
          id={`${id}-other`}
          checked={otherChecked}
          onChange={(e) => update(selected, e.target.checked, e.target.checked ? otherText : "")}
        />
        <label className="form-check-label" htmlFor={`${id}-other`}>อื่นๆ</label>
      </div>
      {otherChecked && (
        <input
          type="text"
          className="form-control mt-1"
          aria-label="ระบุโรคร่วมอื่นๆ"
          placeholder="ระบุโรคร่วมอื่นๆ"
          value={otherText}
          onChange={(e) => update(selected, otherChecked, e.target.value)}
        />
      )}
    </fieldset>
  );
};

const Incoming = () => {
  const { currentUser } = useAuth();
  const getSignedUrl = httpsCallable(functions, "getSignedUrl");
  const registerPatient = httpsCallable(functions, "registerIncomingPatient", { timeout: 540000 });
  const linkPatient = httpsCallable(functions, "linkIncomingPatient", { timeout: 540000 });
  const isSuperAdmin = (currentUser.roles || []).includes("super_admin");
  const canCreateIncoming = isSuperAdmin || (currentUser.roles || []).includes("admin");

  const [loading, setLoading] = useState(true);
  const [IncomingPatientsList, setIncomingPatientsList] = useState([]);
  const [nodesList, setNodesList] = useState([]);
  const [adminProfile, setAdminProfile] = useState(null);
  const [lookupsLoaded, setLookupsLoaded] = useState(false);
  const incomingRequestRef = useRef(0);
  const [allCustomers, setAllCustomers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 50;
  const [queryField, setQueryField] = useState("firstname");
  const [queryText, setQueryText] = useState("");
  const [queryStatus, setQueryStatus] = useState("");
  const [queryNode, setQueryNode] = useState("");
  const [queryCustomer, setQueryCustomer] = useState("");
  const [queryNoSleepStudyDate, setQueryNoSleepStudyDate] = useState(false);
  const [overviewCustomerChoice, setOverviewCustomerChoice] = useState("CHG03");
  const [errors, setErrors] = useState({});
  const profileRef = useRef({ ...profileData });
  const [createStatus, setCreateStatus] = useState(profileData.status);
  const [createBookingScope, setCreateBookingScope] = useState({ node: "", customer: "" });
  const savingRef = useRef(false);
  const createStudyDateRef = useRef(null);
  const createIncomingIdRef = useRef(null);
  const editStudyDateRef = useRef(null);
  const [saving, setSaving] = useState(false);
  const [notesList, setNotesList] = useState([]);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const localPreviewRef = useRef(null);
  const [title, setTitle] = useState("OPD Card");
  const [detail, setDetail] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [previewFileName, setPreviewFileName] = useState("");
  const [previewFileType, setPreviewFileType] = useState("");
  const [showModalImage, setShowModalImage] = useState(false);

  const [noteImageURLs, setNoteImageURLs] = useState({});
  const [loadingFilePreviews, setLoadingFilePreviews] = useState(false);
  const attachmentRequestRef = useRef(0);
  // const [fileNames, setFilenames] = useState([]);

  const clearLocalPreview = () => {
    if (localPreviewRef.current) URL.revokeObjectURL(localPreviewRef.current.url);
    localPreviewRef.current = null;
  };
  useEffect(() => () => {
    attachmentRequestRef.current += 1;
    if (localPreviewRef.current) URL.revokeObjectURL(localPreviewRef.current.url);
  }, []);
  const previewSelectedFile = (file) => {
    clearLocalPreview();
    const url = URL.createObjectURL(file);
    localPreviewRef.current = { file, url };
    setPreviewImage(url);
    setPreviewFileName(file.name);
    setPreviewFileType(file.type);
  };
  const previewSavedFile = (note) => {
    clearLocalPreview();
    setPreviewImage(noteImageURLs[note.fileKey]);
    setPreviewFileName(note.filename[0]);
    setPreviewFileType("");
    setShowModalImage(true);
  };
  const resetSelectedFiles = () => {
    clearLocalPreview();
    setSelectedFiles([]);
    setPreviewImage(null);
    setPreviewFileName("");
    setPreviewFileType("");
    setShowModalImage(false);
  };
  const onFilesChange = (e) => {
    const newFiles = Array.from(e.target.files || []);
    e.target.value = "";
    if (savingRef.current || !newFiles.length) return;
    setSelectedFiles((previous) => appendIncomingFiles(previous, newFiles, notesList.flatMap((note) => note.filename || [])));
  };

  const removeFile = (index) => {
    if (savingRef.current) return;
    if (localPreviewRef.current) {
      clearLocalPreview();
      setPreviewImage(null);
      setShowModalImage(false);
    }
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const saveSelectedIncomingFiles = async (patient) => {
    if (!selectedFiles.length) return;
    const saved = await saveIncomingFiles(patient, {
      title: "OPD Card", detail: "", createBy: currentUser.displayName,
      createAt: new Date(), updateAt: new Date(),
    }, selectedFiles);
    resetSelectedFiles();
    const notes = getVisibleIncomingFiles(patient, [saved]);
    setNotesList((previous) => [...previous, ...notes]);
    const location = getIncomingNoteLocation(patient);
    const previews = await Promise.allSettled(notes.map(async (note) => {
      const result = await getSignedUrl({ folder: location.folder, hn: location.recordId, id: note.id, filename: note.filename[0] });
      return [note.fileKey, result.data];
    }));
    setNoteImageURLs((previous) => ({ ...previous, ...Object.fromEntries(previews.filter((result) => result.status === "fulfilled").map((result) => result.value)) }));
  };

  const handleUploadIncomingFiles = async () => {
    if (savingRef.current || !selectedFiles.length || !originalPatientRef.current) return;
    savingRef.current = true;
    setSaving(true);
    try {
      await saveSelectedIncomingFiles(originalPatientRef.current);
      notifyTopRight("Files uploaded successfully!");
    } catch (error) {
      notifyError(`Files could not be uploaded. Selected files are kept for retry. ${error.message || ""}`);
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const onRemoveIncomingFile = async (note) => {
    if (savingRef.current || !selectedPatient || !deleteAllowed.some((role) => (currentUser.roles || []).includes(role))) return;
    savingRef.current = true;
    setSaving(true);
    try {
      const confirmed = await swal({
        title: "Remove file from Incoming Patient?",
        text: "The file will remain available in the patient profile.",
        icon: "warning",
        buttons: ["Cancel", "Remove"],
        dangerMode: true,
      });
      if (!confirmed) return;
      const removedIncomingFiles = await removeIncomingFile(selectedPatient, note.id, note.filename[0]);
      const updatedPatient = { ...selectedPatient, removedIncomingFiles };
      setSelectedPatient(updatedPatient);
      originalPatientRef.current = { ...originalPatientRef.current, removedIncomingFiles };
      setIncomingPatientsList((patients) => patients.map((patient) =>
        patient.id === selectedPatient.id ? { ...patient, removedIncomingFiles } : patient));
      setNotesList((notes) => notes.filter((file) => !removedIncomingFiles.includes(file.fileKey)));
      setPreviewImage(null);
      setShowModalImage(false);
      notifyTopRight("File removed from Incoming Patient");
    } catch (error) {
      notifyError(error.message || "Unable to remove the file from Incoming Patient");
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };
  const deleteAllowed = ["admin", "super_admin", "staff"];
  const [showCreateModal, setShowCreateModal] = useState(false);
  const handleShow = () => {
    if (!canCreateIncoming) return;
    resetSelectedFiles();
    setNotesList([]);
    setTitle("OPD Card");
    setDetail("");
    const defaults = getIncomingAssignedDefaults(currentUser, nodesList, allCustomers);
    profileRef.current = { ...profileData, nodeRef: defaults.node, refCustomer: defaults.customer };
    setCreateStatus(profileData.status);
    setCreateBookingScope(defaults);
    createIncomingIdRef.current = null;
    const index = nodesList.findIndex((node) => node.nodename === defaults.node);
    setCustomers(index === -1 ? [] : allCustomers[index] || []);
    setShowCreateModal(true);
  };
  const handleClose = () => {
    if (savingRef.current) return;
    profileRef.current = { ...profileData };
    setTitle("");
    setDetail("");
    resetSelectedFiles();
    setShowCreateModal(false);
    setPreviewImage(null);
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const originalPatientRef = useRef(null);
  const [editingHn, setEditingHn] = useState(false);
  const [companyHn, setCompanyHn] = useState("");
  const [fetchingHn, setFetchingHn] = useState(false);
  const [hnMatches, setHnMatches] = useState(null);
  const [selectedMatchHn, setSelectedMatchHn] = useState("");
  const hnLookupRequestRef = useRef(0);
  const resetHnLookup = () => {
    hnLookupRequestRef.current += 1;
    setFetchingHn(false);
    setHnMatches(null);
    setSelectedMatchHn("");
  };
  useEffect(() => () => { hnLookupRequestRef.current += 1; }, []);
  const handleEditModalClose = () => {
    if (savingRef.current) return;
    attachmentRequestRef.current += 1;
    resetHnLookup();
    setSelectedPatient(null);
    originalPatientRef.current = null;
    setEditingHn(false);
    setCompanyHn("");
    setPreviewImage(null);
    setShowEditModal(false);
    setNotesList([]);
    resetSelectedFiles();
  };
  // const handleEditModalShow = async (patient) => {
  //   setSelectedPatient(patient);

  //   await onChangeNodeEdit(patient.nodeRef, patient);
  //   // 🔽 Get all notes from patients/{hn}/note
  //   const notesRef = collection(db, "patients", patient.hn, "note");
  //   const querySnapshot = await getDocs(notesRef);

  //   const notes = querySnapshot.docs.map((doc) => ({
  //     id: doc.id,
  //     ...doc.data(),
  //   }));
  //   setNotesList(notes);
  //   setShowEditModal(true);
  // };

  const handleEditModalShow = async (patient) => {
    const requestId = ++attachmentRequestRef.current;
    resetSelectedFiles();
    resetHnLookup();
    originalPatientRef.current = { ...patient };
    setSelectedPatient({ ...patient });
    setEditingHn(false);
    setCompanyHn(patient.hn || "");

    await onChangeNodeEdit(patient.nodeRef, patient);

    const noteLocation = getIncomingNoteLocation(patient);
    const noteLocations = [noteLocation];
    // Booking can assign an HN without moving the original Incoming files.
    if (patient.hn && patient.id) noteLocations.push(getIncomingNoteLocation({ id: patient.id }));
    const snapshots = await Promise.all(noteLocations.map((location) =>
      getDocs(collection(db, location.collectionName, location.recordId, "note"))));
    if (requestId !== attachmentRequestRef.current) return;

    const notes = getVisibleIncomingFiles(patient, snapshots.flatMap((snapshot, index) => snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
      noteLocation: noteLocations[index],
    }))));

    setNotesList(notes);
    setNoteImageURLs({});
    setLoadingFilePreviews(notes.length > 0);
    setShowEditModal(true);

    // Show the form immediately and load previews with limited concurrency.
    const pending = [...notes];
    await Promise.allSettled(Array.from({ length: Math.min(6, pending.length) }, async () => {
      while (pending.length && requestId === attachmentRequestRef.current) {
        const note = pending.shift();
        try {
          const result = await getSignedUrl({
            folder: note.noteLocation.folder,
            hn: note.noteLocation.recordId,
            id: note.id,
            filename: note.filename[0],
          });
          if (requestId === attachmentRequestRef.current) {
            setNoteImageURLs((previous) => ({ ...previous, [note.fileKey]: result.data }));
          }
        } catch (err) {
          console.error(`Failed to get image URL for note ${note.id}`, err);
        }
      }
    }));
    if (requestId === attachmentRequestRef.current) setLoadingFilePreviews(false);
  };

  const drop = async (id) => {
    return (
      <Dropdown>
        <Dropdown.Toggle
          variant="link"
          id="dropdown-basic"
          className="btn btn-link text-danger"
        >
          <i className="la la-trash" />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              swal({
                title: "คุณต้องการลบข้อมูลหรือไม่",
                text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้",
                icon: "warning",
                buttons: true,
                dangerMode: true,
              }).then((willDelete) => {
                if (willDelete) {
                  deletePatient(id);
                }
              });
            }}
          >
            ลบข้อมูลผู้ป่วย
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const deletePatient = async (patient) => {
    try {
      await deleteIncomingRecord(patient);
      notifyTopRight("ลบข้อมูลผู้ป่วยสำเร็จ");
      getInconmingPatients();
    } catch (error) {
      notifyError(error.details && error.details.reason ? incomingBookingErrorMessage(error, patient.sleepStudyDate, patient.refCustomer) : "เกิดข้อผิดพลาดในการลบข้อมูลผู้ป่วย");
      if (error.details && error.details.latestSleepStudyDate) await getInconmingPatients();
    }
  };

  const validateForm = () => {
    const requiredFields = [
      { name: "nodeRef", label: "Node" },
      { name: "status", label: "สถานะ" },
      { name: "refCustomer", label: "Customer" },
      { name: "titleTh", label: "คำนำหน้า" },
      { name: "firstnameTh", label: "ชื่อ" },
      { name: "lastnameTh", label: "นามสกุล" },
      // { name: "nationalId", label: "เลขบัตรประจำตัวประชาชน" },
      { name: "refHn", label: "รหัสโรงพยาบาลอ้างอิง" },
      { name: "dateOfBirth", label: "วันเดือนปีเกิด" },
      { name: "gender", label: "เพศ" },
      { name: "mobile", label: "เบอร์ติดต่อ" },
      { name: "healthInsurance", label: "สิทธิการเบิก" },
    ];

    const missingFields = requiredFields.filter(
      (field) =>
        !String(profileRef.current[field.name] || "").trim()
    );

    if (missingFields.length > 0) {
      const missingFieldNames = missingFields
        .map((field) => field.label)
        .join(", ");
      notifyError(`Please fill in required fields: ${missingFieldNames}`);

      // Focus on first missing field (optional)
      const firstMissingField = document.querySelector(
        `[name="${missingFields[0].name}"]`
      );
      if (firstMissingField) {
        firstMissingField.focus();
      }

      return false;
    }

    return true;
  };

  const validatePatient = (patient) => {
    const requiredFields = [
      "status",
      "refCustomer",
      "titleTh",
      "firstnameTh",
      "lastnameTh",
      // "nationalId",
      "refHn",
      "dateOfBirth",
      "gender",
      "mobile",
      "healthInsurance",
    ];

    const missingFields = requiredFields.filter(
      (field) => !String(patient[field] || "").trim()
    );

    if (missingFields.length > 0) {
      const friendlyNames = {
        status: "สถานะ",
        refCustomer: "Customer",
        titleTh: "คำนำหน้า",
        firstnameTh: "ชื่อ",
        lastnameTh: "นามสกุล",
        // nationalId: "เลขบัตรประจำตัวประชานะ",
        refHn: "รหัสโรงพยาบาลอ้างอิง",
        dateOfBirth: "วันเดือนปีเกิด",
        gender: "เพศ",
        mobile: "เบอร์ติดต่อ",
        healthInsurance: "สิทธิการเบิก",
      };

      const missingNames = missingFields
        .map((field) => friendlyNames[field])
        .join(", ");
      notifyError(`Missing required fields: ${missingNames}`);
      return false;
    }
    return true;
  };

  const restoreLatestIncomingDate = async (error, patient) => {
    const correction = error.details;
    if (!correction || !correction.incomingId || !correction.latestSleepStudyDate) return;
    if (patient) {
      originalPatientRef.current = { ...originalPatientRef.current, sleepStudyDate: correction.latestSleepStudyDate, status: correction.incomingStatus };
      setSelectedPatient((current) => ({ ...current, sleepStudyDate: correction.latestSleepStudyDate, status: correction.incomingStatus }));
    } else {
      profileRef.current.sleepStudyDate = correction.latestSleepStudyDate;
      profileRef.current.status = correction.incomingStatus;
      setCreateStatus(correction.incomingStatus);
      setCreateBookingScope((scope) => ({ ...scope }));
    }
    await getInconmingPatients();
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!canCreateIncoming || savingRef.current) return;
    if (!e.target.checkValidity()) {
      e.target.reportValidity(); // 🟢 show error
      e.stopPropagation();
      return;
    }
    if (!validateForm()) {
      return;
    }

    if (!nodesList.some((node) => node.nodename === profileRef.current.nodeRef)) {
      notifyError("Node not found");
      return;
    }
    savingRef.current = true;
    setSaving(true);
    try {
      // The server checks the patient's latest booking before capacity. A
      // full day is valid when the patient already owns a booking that day.
      if (!createIncomingIdRef.current) createIncomingIdRef.current = doc(collection(db, "incoming")).id;
      const incomingId = await createIncomingRecord(profileRef.current, createIncomingIdRef.current);
      let noteFailed = false;
      try {
        if (selectedFiles.length || title || detail) {
          await saveIncomingNote(incomingId, {
            title,
            detail,
            createBy: currentUser.displayName,
            updateAt: new Date(),
            createAt: new Date(),
          }, selectedFiles);
        }
      } catch (error) {
        noteFailed = true;
        notifyError("Incoming patient saved, but the note or attachment could not be saved.");
      }
      if (!noteFailed) notifyTopRight("Create Incoming Patient Success");
      savingRef.current = false;
      handleClose();
      await getInconmingPatients();
    } catch (error) {
      if (error.details && error.details.reason && error.details.reason !== "incoming-duplicate" && !error.details.latestSleepStudyDate && createStudyDateRef.current) {
        await createStudyDateRef.current.checkAvailability(profileRef.current.sleepStudyDate).catch(() => {});
      }
      notifyError(getIncomingBookingPolicy(profileRef.current.refCustomer)
        ? incomingBookingErrorMessage(error, profileRef.current.sleepStudyDate, profileRef.current.refCustomer)
        : error.message || "Unable to save or refresh the incoming patient. Please check the list before trying again.");
      await restoreLatestIncomingDate(error);
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const submitEditHandler = async (e, patient) => {
    e.preventDefault();
    if (savingRef.current) return;
    if (editingHn && companyHn.trim() !== (patient.hn || "")) {
      notifyError("Use Create Patient or Save Company HN to save the Company HN change, or cancel HN editing.");
      return;
    }
    if (!e.target.checkValidity()) {
      e.target.reportValidity(); // 🟢 show error
      e.stopPropagation();
      return;
    }

    if (!validatePatient(patient)) {
      return;
    }

    savingRef.current = true;
    setSaving(true);
    try {
      await updateIncomingRecord(patient, originalPatientRef.current || patient);
      if (selectedFiles.length) {
        try {
          const saved = await getDoc(doc(db, "incoming", patient.id));
          if (!saved.exists() || (saved.data().hn || "") !== (patient.hn || "")) throw new Error("Company HN changed. Reopen the incoming patient.");
          const refreshed = { ...saved.data(), id: patient.id };
          originalPatientRef.current = refreshed;
          setSelectedPatient(refreshed);
          await saveSelectedIncomingFiles(refreshed);
        } catch (error) {
          notifyError(`Incoming patient updated, but attachments could not be saved. Selected files are kept for retry. ${error.message || ""}`);
          return;
        }
      }
      notifyTopRight("Incoming patient updated successfully!");
      savingRef.current = false;
      handleEditModalClose();
      await getInconmingPatients();
    } catch (error) {
      if (error.details && error.details.reason && !error.details.latestSleepStudyDate && editStudyDateRef.current) {
        await editStudyDateRef.current.checkAvailability(patient.sleepStudyDate).catch(() => {});
      }
      notifyError(getIncomingBookingPolicy(patient.refCustomer) || patient.incomingBooking
        ? incomingBookingErrorMessage(error, patient.sleepStudyDate, patient.refCustomer)
        : error.message || "Unable to update the incoming patient.");
      await restoreLatestIncomingDate(error, patient);
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const handleRegisterPatient = async () => {
    if (!isSuperAdmin || savingRef.current || !selectedPatient) return;
    const pendingChange = selectedPatient.patientHnChange && selectedPatient.patientHnChange.authPending;
    if (!editingHn && !pendingChange) return;
    const hn = pendingChange ? selectedPatient.patientHnChange.to : companyHn.trim();
    if (!hn || hn.includes("/") || hn === "." || hn === ".." || /^__.*__$/.test(hn)) {
      notifyError("Enter a valid Company HN manually.");
      return;
    }
    if (!pendingChange && !validatePatient(selectedPatient)) return;
    const previousHn = pendingChange ? selectedPatient.patientHnChange.from : selectedPatient.hn || "";
    if (hn === previousHn) {
      setEditingHn(false);
      return;
    }
    savingRef.current = true;
    setSaving(true);
    try {
      if (previousHn && !pendingChange) {
        const confirmed = await swal({
          title: "Change Company HN?",
          text: `This will delete the old patient (${previousHn}) from the patients collection and create a new patient (${hn}). All linked history and files will move to the new HN. Are you sure?`,
          icon: "warning",
          buttons: ["Cancel", "Change HN and Move History"],
          dangerMode: true,
        });
        if (!confirmed) return;
      }
      const profile = Object.fromEntries(Object.entries(selectedPatient).filter(([key, value]) => value !== (originalPatientRef.current || {})[key]));
      await saveSelectedIncomingFiles(selectedPatient);
      await registerPatient({ incomingId: selectedPatient.id, hn, previousHn, confirmReplace: Boolean(previousHn), profile });
      notifyTopRight(previousHn ? "Company HN changed and patient history moved successfully." : "Patient created successfully.");
      savingRef.current = false;
      handleEditModalClose();
      await getInconmingPatients();
    } catch (error) {
      notifyError(error.message || "Unable to create the patient or change Company HN. Please retry.");
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target; // Get field name and value
    if (name === "sleepStudyDate" && value && value !== profileRef.current.sleepStudyDate) {
      profileRef.current.status = "Appointed";
      setCreateStatus("Appointed");
    }
    profileRef.current[name] = value; // Update the ref object
    if (name === "status") {
      if (value === "Cancel") profileRef.current.sleepStudyDate = "";
      setCreateStatus(value);
    }
    if (name === "refCustomer") setCreateBookingScope({ node: profileRef.current.nodeRef, customer: value });
  };

  const handleInputChangeEdit = (e) => {
    const { name, value } = e.target;
    if (["firstnameTh", "lastnameTh", "firstnameEn", "lastnameEn"].includes(name)) resetHnLookup();

    setSelectedPatient((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "status" && value === "Cancel" ? { sleepStudyDate: "" } : {}),
      ...(name === "sleepStudyDate" && value && value !== prev.sleepStudyDate ? { status: "Appointed" } : {}),
    }));
  };

  const handleFetchCompanyHn = async () => {
    if (!isSuperAdmin || !selectedPatient || savingRef.current || fetchingHn) return;
    resetHnLookup();
    if (!getIncomingPatientNameKeys(selectedPatient).length) {
      notifyError("Enter both first name and last name before fetching Company HN.");
      return;
    }
    const requestId = hnLookupRequestRef.current;
    setFetchingHn(true);
    try {
      // Existing patient documents have no normalized-name field. Normalize
      // on demand so older spacing/capitalization does not hide valid matches.
      const snapshot = await getDocs(collection(db, "patients"));
      if (requestId !== hnLookupRequestRef.current) return;
      setHnMatches(findIncomingPatientNameMatches(selectedPatient, snapshot.docs.map((item) => ({ ...item.data(), id: item.id }))));
    } catch (error) {
      if (requestId === hnLookupRequestRef.current) notifyError("Unable to fetch Company HN. Please try again.");
    } finally {
      if (requestId === hnLookupRequestRef.current) setFetchingHn(false);
    }
  };

  const handleLinkPatient = async () => {
    if (!isSuperAdmin || !selectedPatient || selectedPatient.hn || savingRef.current) return;
    const match = (hnMatches || []).find((patient) => patient.hn === selectedMatchHn);
    if (!match) return;
    savingRef.current = true;
    setSaving(true);
    try {
      const confirmed = await swal({
        title: "Link Existing Patient?",
        text: `Link this incoming record to Company HN ${match.hn}? The existing patient details and history will be preserved. Incoming attachments will be added to that patient.`,
        icon: "warning",
        buttons: ["Cancel", "Link Patient"],
      });
      if (!confirmed) return;
      const profile = Object.fromEntries(Object.entries(selectedPatient).filter(([key, value]) => value !== (originalPatientRef.current || {})[key]));
      await saveSelectedIncomingFiles(selectedPatient);
      await linkPatient({ incomingId: selectedPatient.id, hn: match.hn, profile, confirmLink: true });
      notifyTopRight("Incoming record linked to the existing patient successfully.");
      savingRef.current = false;
      handleEditModalClose();
      await getInconmingPatients();
    } catch (error) {
      notifyError(error.message || "Unable to link the selected patient. Fetch Company HN and try again.");
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const getNodes = async () => {
    const nodes = await getDocs(collection(db, "nodes"));
    if (
      currentUser.roles.some((role) => ["super_admin", "accountant"].includes(role))
    ) {
      const tempNodes = nodes.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      const nodesFiltered = tempNodes.sort((a, b) =>
        a.nodename.localeCompare(b.nodename)
      );

      const allnodeIdDocs = nodesFiltered.map((doc) => doc.id);
      const allCustomers = [];

      for (const id of allnodeIdDocs) {
        const customerDocs = await getDocs(
          collection(db, "nodes", id, "customers")
        );
        const customersData = customerDocs.docs.map((customer) => {
          const customerData = customer.id;
          return customerData;
        });
        allCustomers.push(customersData);
      }
      setNodesList(nodesFiltered);
      setAdminProfile(null);
      setAllCustomers(allCustomers);
      setCustomers([]);
      console.log("Nodes -> Done!");
    } else {
      const currentAdmin = await getDoc(
        doc(db, "admins", currentUser.displayName)
      );
      const currentAdminData = currentAdmin.exists()
        ? currentAdmin.data()
        : {};
      const currentNodeValue = currentAdminData.node || [];
      const currentNode = Array.isArray(currentNodeValue)
        ? currentNodeValue
        : [currentNodeValue];
      const tempNodes = nodes.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      // Filter nodes based on the current user's node
      const nodesFiltered = tempNodes
        .filter((doc) => currentNode.includes(doc.nodecode))
        .sort((a, b) => a.nodename.localeCompare(b.nodename));

      const allnodeIdDocs = nodesFiltered.map((doc) => doc.id);
      const allCustomers = [];

      for (const nodeData of nodesFiltered) {
        const customerDocs = await getDocs(
          collection(db, "nodes", nodeData.id, "customers")
        );
        const allowedCustomers = filterCustomersForStaffNode({
          customers: customerDocs.docs,
          currentUser,
          adminData: currentAdminData,
          nodeCode: nodeData.nodecode,
          getCustomerId: (customerDoc) => customerDoc.id,
        });
        const customersData = allowedCustomers.map((customer) => {
          const customerData = customer.id;
          return customerData;
        });
        allCustomers.push(customersData);
      }
      setNodesList(nodesFiltered);
      setAdminProfile(currentAdminData);
      setAllCustomers(allCustomers);
      setCustomers([]);
      const defaults = getIncomingAssignedDefaults(currentUser, nodesFiltered, allCustomers);
      setQueryNode(defaults.node);
      setQueryCustomer(defaults.customer);
      console.log("Nodes -> Done!");
    }
  };

  const onChangeNode = async (nodename) => {
    profileRef.current["refCustomer"] = getIncomingAssignedDefaults(currentUser, nodesList, allCustomers, nodename).customer;
    setCreateBookingScope({ node: nodename, customer: profileRef.current.refCustomer });
    if (nodename == "") {
      setCustomers([]);
      profileRef.current["nodeRef"] = "";
      profileRef.current["refCustomer"] = "";
      return;
    } else {
      profileRef.current["nodeRef"] = nodename;
    }
    const index = nodesList.findIndex((node) => node.nodename === nodename);
    if (index !== -1) {
      // console.log("Found at index:", index);
      // You can use index here as needed
      // console.log("index: ",index)
      // console.log("allCustomers: ",allCustomers)
      setCustomers(allCustomers[index]);
    } else {
      setCustomers([]);
      console.log("Node not found");
    }
  };

  const onChangeNodeEdit = async (nodename, patient) => {
    if (nodename == "") {
      setCustomers([]);
      patient["nodeRef"] = "";
      patient["refCustomer"] = "";
      return;
    } else {
      patient["nodeRef"] = nodename;
    }
    const index = nodesList.findIndex((node) => node.nodename === nodename);
    const nodeFiltered = nodesList.filter((node) => node.nodename === nodename);
    console.log("nodeFiltered", nodeFiltered);
    if (nodeFiltered.length > 0) {
      const nodeIndex = nodeFiltered[0].nodeIndex;
    } else {
      console.log("Node not found");
    }
    if (index !== -1) {
      // console.log("Found at index:", index);
      // You can use index here as needed
      // console.log("index: ",index)
      // console.log("allCustomers: ",allCustomers)
      setCustomers(allCustomers[index]);
    } else {
      setCustomers([]);
      console.log("Node not found");
    }
  };

  // const getInconmingPatients = async () => {
  //   const nodesAdmin = nodesList.map((node) => node.nodename);
  //   const roles = currentUser.roles[0];
  //   const q = query(
  //     collection(db, "incoming"),
  //     orderBy("hn"),
  //     limit(itemsPerPage),
  //   );
  //   const querySnapshot = await getDocs(q);
  //   const patientsList = [];
  //   querySnapshot.forEach((doc) => {
  //     patientsList.push({ ...doc.data(), id: doc.id });
  //   });
  //   console.log("patientsList", patientsList);
  //   setIncomingPatientsList(patientsList);
  //   setLoading(false);
  // };

  const getInconmingPatients = async () => {
    const requestId = ++incomingRequestRef.current;
    setLoading(true);
    const nodesAdmin = nodesList.map((node) => node.nodename);
    const canReadAllNodes = currentUser.roles.some((role) => ["super_admin", "sale", "accountant"].includes(role));
    try {
      const incomingRef = collection(db, "incoming");
      const queries = [];
      if (canReadAllNodes) queries.push(query(incomingRef, orderBy("hn")));
      else {
        // Empty assignments read nothing; chunks also support users with many nodes.
        for (let index = 0; index < nodesAdmin.length; index += 10) {
          queries.push(query(incomingRef, orderBy("hn"), where("nodeRef", "in", nodesAdmin.slice(index, index + 10))));
        }
      }
      const snapshots = await Promise.all(queries.map((item) => getDocs(item)));
      if (requestId !== incomingRequestRef.current) return;
      const patientsList = [];
      snapshots.forEach((snapshot) => snapshot.forEach((doc) => patientsList.push({ ...doc.data(), id: doc.id })));
      const visiblePatients = filterRecordsByStaffCustomerAccess({
        records: patientsList,
        currentUser,
        adminData: adminProfile,
        nodes: nodesList,
        getNodeValue: (patient) => patient.nodeRef,
        getCustomerValue: (patient) => patient.refCustomer,
      });
      setIncomingPatientsList(sortIncomingRecords(visiblePatients));
    } catch (error) {
      if (requestId === incomingRequestRef.current) {
        setIncomingPatientsList([]);
        notifyError("Unable to load incoming patients.");
      }
    } finally {
      if (requestId === incomingRequestRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    let active = true;
    getNodes().catch(() => {
      if (active) {
        setNodesList([]);
        setAdminProfile({});
        notifyError("Unable to load incoming patient access.");
      }
    }).finally(() => { if (active) setLookupsLoaded(true); });
    return () => { active = false; incomingRequestRef.current += 1; };
  }, []);

  useEffect(() => {
    if (lookupsLoaded) getInconmingPatients();
  }, [lookupsLoaded, nodesList, adminProfile]);

  const filteredPatients = filterIncomingRecords(IncomingPatientsList, {
    node: queryNode, customer: queryCustomer, status: queryStatus, field: queryField, search: queryText,
    noSleepStudyDate: queryNoSleepStudyDate,
  });
  const totalPages = Math.max(1, Math.ceil(filteredPatients.length / itemsPerPage));
  const currentPage = Math.min(page, totalPages);
  const pageStart = (currentPage - 1) * itemsPerPage;
  const pagedPatients = filteredPatients.slice(pageStart, pageStart + itemsPerPage);
  useEffect(() => { setPage(1); }, [queryNode, queryCustomer, queryStatus, queryField, queryText, queryNoSleepStudyDate]);
  useEffect(() => { setPage((previous) => Math.min(previous, totalPages)); }, [totalPages]);
  const filterCustomers = getIncomingCustomerOptions(nodesList, allCustomers, IncomingPatientsList, queryNode);
  const overviewPolicy = getIncomingBookingPolicy(queryCustomer);
  const overviewCustomers = ["CHG03", "CHG11"].filter((customer) => nodesList.some((node, index) =>
    (allCustomers[index] || []).some((value) => (getIncomingBookingPolicy(value) || {}).customer === customer)));
  const overviewCustomer = isSuperAdmin
    ? (overviewCustomers.includes(overviewCustomerChoice) ? overviewCustomerChoice : overviewCustomers[0]) || "CHG03"
    : overviewPolicy ? overviewPolicy.customer : ["CHG03", "CHG11"].find((customer) =>
    nodesList.some((node, index) => (!queryNode || node.nodename === queryNode) && (allCustomers[index] || []).some((value) =>
      (getIncomingBookingPolicy(value) || {}).customer === customer))) || "CHG03";
  const overviewNodes = lookupsLoaded && (isSuperAdmin || overviewPolicy || (!queryCustomer && isStaffCustomerScopedUser(currentUser)))
    ? nodesList.filter((node, index) => (isSuperAdmin || !queryNode || node.nodename === queryNode) && (allCustomers[index] || []).some((value) =>
      (getIncomingBookingPolicy(value) || {}).customer === overviewCustomer))
    : [];
  const clearFilters = () => {
    const defaults = getIncomingAssignedDefaults(currentUser, nodesList, allCustomers);
    setQueryNode(defaults.node);
    setQueryCustomer(defaults.customer);
    setQueryStatus("");
    setQueryText("");
    setQueryField("firstname");
    setQueryNoSleepStudyDate(false);
  };
  const exportIncomingPatients = () => {
    if (loading || !filteredPatients.length) return;
    try {
      const sheet = XLSX.utils.json_to_sheet(buildIncomingExportRows(filteredPatients));
      sheet["!cols"] = [18, 20, 22, 28, 28, 18, 18, 32, 12, 16, 18, 28, 40].map((wch) => ({ wch }));
      sheet["!autofilter"] = { ref: sheet["!ref"] };
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, "Incoming Patients");
      XLSX.writeFile(workbook, `incoming-patients-${new Date().toISOString().slice(0, 10)}.xlsx`);
    } catch (error) {
      notifyError("Unable to export incoming patients.");
    }
  };

  const filtersPanel = (
        <section className="incoming-filters-panel" aria-label="Incoming patient filters">
          <div className="incoming-filter-heading"><h5>ค้นหาผู้ป่วย</h5>{!loading && <span className="incoming-result-count">พบ {filteredPatients.length} คน</span>}</div>
          <div className="incoming-search-controls">
            <div>
              <label htmlFor="incoming-search-field">ค้นหาจาก</label>
              <select id="incoming-search-field" className="form-control" value={queryField} onChange={(event) => setQueryField(event.target.value)}>
                <option value="firstname">ชื่อผู้ป่วย / Name</option>
                <option value="hn">Company HN</option>
              </select>
            </div>
            <div className="incoming-search-input">
              <label htmlFor="incoming-search-text">ชื่อผู้ป่วย หรือ Company HN</label>
              <input id="incoming-search-text" type="search" className="form-control" placeholder="Search here"
                aria-label="Search incoming patients" value={queryText} onChange={(event) => setQueryText(event.target.value)} />
            </div>
          </div>
          <div className="incoming-scope-controls">
            <div>
              <label htmlFor="incoming-node-filter" >สถานที่ / Node</label>
              <select id="incoming-node-filter" className="form-control" value={queryNode} disabled={loading}
                onChange={(e) => {
                  setQueryNode(e.target.value);
                  setQueryCustomer(getIncomingAssignedDefaults(currentUser, nodesList, allCustomers, e.target.value).customer);
                }}>
                <option value="">All nodes</option>
                {nodesList.map((node) => <option key={node.id} value={node.nodename}>{node.nodename}</option>)}
              </select>
            </div>
            <div>
              <label htmlFor="incoming-customer-filter" >ลูกค้า / Customer</label>
              <select id="incoming-customer-filter" className="form-control" value={queryCustomer} disabled={loading}
                onChange={(e) => setQueryCustomer(e.target.value)}>
                <option value="">All customers</option>
                {filterCustomers.map((customer) => <option key={customer} value={customer}>{customer}</option>)}
              </select>
            </div>
            <div>
              <label htmlFor="incoming-status-filter">สถานะ / Status</label>
              <select id="incoming-status-filter" className="form-control" value={queryStatus} onChange={(event) => setQueryStatus(event.target.value)}>
                <option value="">All</option>
                {statusList.map((status) => <option key={status} value={status}>{status}</option>)}
              </select>
            </div>
          </div>
          <div className="incoming-filter-footer">
            <div className="incoming-date-filter">
              <input id="incoming-no-sleep-study-date" type="checkbox" checked={queryNoSleepStudyDate}
                onChange={(event) => setQueryNoSleepStudyDate(event.target.checked)} />
              <label htmlFor="incoming-no-sleep-study-date">ยังไม่ระบุวันที่ตรวจการนอนหลับ</label>
            </div>
            <Button variant="outline-secondary" onClick={clearFilters}>Clear filters</Button>
          </div>
          <p className="incoming-filter-help">รายการด้านล่างจะเปลี่ยนตามคำค้นและตัวกรองที่เลือก</p>
        </section>
  );

  return (
    <Fragment>
      <Toast />
      <div className="incoming-page-heading">
        <div><h4 className="mb-1">Incoming Patients</h4><p className="incoming-page-description">ตรวจสอบวันว่างและจัดการข้อมูลผู้ป่วยก่อนนัดตรวจ</p></div>
        <div className="incoming-page-actions">
          <Button size="sm" variant="outline-success" disabled={loading || !filteredPatients.length} onClick={exportIncomingPatients}>Export Excel</Button>
          {canCreateIncoming && <Button onClick={handleShow} disabled={!lookupsLoaded} variant="primary">+ New Incoming Patient</Button>}
        </div>
      </div>
      <div className={`incoming-page-workspace ${overviewNodes.length ? "incoming-page-workspace-with-calendar" : ""}`}>
        {overviewNodes.length > 0 ? <IncomingAvailabilityOverview nodes={overviewNodes} customer={overviewCustomer} refreshKey={IncomingPatientsList}
          customerOptions={isSuperAdmin ? overviewCustomers : []} onCustomerChange={isSuperAdmin ? setOverviewCustomerChoice : undefined}
          currentUser={currentUser} adminProfile={adminProfile} incomingPatients={IncomingPatientsList} onEditIncoming={handleEditModalShow}>
          {filtersPanel}
        </IncomingAvailabilityOverview> : filtersPanel}
      </div>
      <p className="small text-muted mb-3">
        Click patient name or status to view incoming details. Click Company HN to open the patient profile.
      </p>

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="incoming-table-scroll" role="region" aria-label="Incoming patients table" tabIndex={0}>
                <table className="table incoming-table mb-0">
                  <caption className="sr-only">Incoming patients with sleep study date, creation time, patient details, HN, status, and customer. Unscheduled orders first, then newest creation time within each group.</caption>
                  <thead>
                    <tr>
                      <th scope="col" className="incoming-study-column">วันที่นัดตรวจการนอนหลับ<span className="incoming-column-hint">dd/mm/yyyy</span></th>
                      <th scope="col" className="incoming-created-column">Created At<span className="incoming-column-hint">Newest first · ICT</span></th>
                      <th scope="col">ชื่อ นามสกุล<span className="incoming-column-hint">เพศ · วันเดือนปีเกิด · เบอร์โทรศัพท์</span></th>
                      <th scope="col">HN<span className="incoming-column-hint">Company / Hospital</span></th>
                      <th scope="col">สถานะ</th>
                      <th scope="col">Customer<span className="incoming-column-hint">Node</span></th>
                      <th scope="col">Health Insurance</th>
                      {deleteAllowed.some((role) => currentUser.roles.includes(role)) && <th scope="col"><span className="sr-only">Actions</span></th>}
                    </tr>
                  </thead>
                  {!loading ? (
                    <tbody id="customers">
                      {!pagedPatients.length && <tr><td colSpan={deleteAllowed.some((role) => currentUser.roles.includes(role)) ? 8 : 7} className="incoming-empty">
                        <strong>No incoming patients found</strong>
                        <span className="d-block text-muted mt-1">Try another search or clear the filters.</span>
                      </td></tr>}
                      {pagedPatients.map((patientElement) => {
                        const patientName = [patientElement.firstnameTh, patientElement.lastnameTh].filter(Boolean).join(" ") ||
                          [patientElement.firstnameEn, patientElement.lastnameEn].filter(Boolean).join(" ") || "—";
                        const statusTone = { Pending: "pending", "On Hold": "hold", Appointed: "appointed", Cancel: "cancel" }[patientElement.status] || "unknown";
                        return (
                          <tr key={patientElement.id}>
                            <td className="incoming-study-column">
                              {formatIncomingDate(patientElement.sleepStudyDate) ?
                                <span className="incoming-study-date">{formatIncomingDate(patientElement.sleepStudyDate)}</span> :
                                <span className="text-muted small">ยังไม่ระบุวันที่</span>}
                            </td>
                            <td className="incoming-created-column">{formatIncomingCreatedAt(patientElement.createdAt) || <span className="text-muted">—</span>}</td>
                            <td className="incoming-patient-column">
                              <button type="button" className="incoming-patient-name" onClick={() => handleEditModalShow(patientElement)}>{patientName}</button>
                              <div className="incoming-secondary">{patientElement.gender || "—"} · <span>{formatIncomingDate(patientElement.dateOfBirth) || "—"}</span></div>
                              <div className="incoming-secondary">โทร: {patientElement.mobile || "—"}</div>
                            </td>
                            <td className="incoming-hn-column">
                              <div className="incoming-secondary">Company HN</div>
                              {patientElement.hn ? <Link className="font-weight-bold" to={"/patient-page/" + patientElement.hn}>{patientElement.hn}</Link> : <span className="text-muted">—</span>}
                              <div className="incoming-secondary mt-1">Hospital HN: {patientElement.refHn || "—"}</div>
                            </td>
                            <td>
                              <button type="button" className={`incoming-status incoming-status-${statusTone}`} onClick={() => handleEditModalShow(patientElement)}>
                                {statusIcons[patientElement.status] && <img src={statusIcons[patientElement.status]} alt="" width="16" height="16" />}
                                {patientElement.status || "—"}
                              </button>
                              <div className="mt-2">
                                <button type="button" className={`incoming-registration ${patientElement.hn ? "text-success" : "text-muted"}`} onClick={() => handleEditModalShow(patientElement)}
                                  title={patientElement.hn ? "A patient has been created or linked, and Company HN is available." : "No patient has been created or linked to this incoming record yet."}>
                                  {patientElement.hn ? "Patient Created" : "Not Created"}
                                </button>
                              </div>
                            </td>
                            <td className="incoming-customer-column">
                              <span className="font-weight-bold">{patientElement.refCustomer || "—"}</span>
                              <div className="incoming-secondary">{patientElement.nodeRef || "—"}</div>
                            </td>
                            <td className="incoming-insurance-column">{patientElement.healthInsurance || "—"}</td>
                            {deleteAllowed.some((allowed) =>
                              currentUser.roles.includes(allowed)
                            ) && (
                              <td className="py-2 text-right">
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="link"
                                    id="dropdown-basic"
                                    className="btn btn-link text-danger"
                                    aria-label={`Delete incoming patient ${patientName}`}
                                  >
                                    <i className="la la-trash" />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() => {
                                        swal({
                                          title: "คุณต้องการลบข้อมูลหรือไม่",
                                          text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้",
                                          icon: "warning",
                                          buttons: true,
                                          dangerMode: true,
                                        }).then((willDelete) => {
                                          if (willDelete) {
                                            deletePatient(patientElement);
                                          }
                                        });
                                      }}
                                    >
                                      ลบข้อมูลผู้ป่วย
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>{" "}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tbody><tr><td colSpan={deleteAllowed.some((role) => currentUser.roles.includes(role)) ? 8 : 7} className="incoming-empty">
                      <div role="status"><span className="spinner-border spinner-border-sm mr-2" aria-hidden="true" />Loading incoming patients…</div>
                    </td></tr></tbody>
                  )}
                </table>
              </div>

                {!loading && <nav aria-label="Incoming patient pages" className="d-flex flex-wrap justify-content-between align-items-center mt-3">
                  <span className="small text-muted mb-2">
                    Showing {filteredPatients.length ? pageStart + 1 : 0}–{pageStart + pagedPatients.length} of {filteredPatients.length} cases
                  </span>
                  <div className="d-flex align-items-center mb-2">
                    <Button size="sm" variant="outline-primary" className="mr-1" disabled={currentPage === 1} onClick={() => setPage(1)}>First</Button>
                    <Button size="sm" variant="outline-primary" className="mr-2" disabled={currentPage === 1} onClick={() => setPage(currentPage - 1)}>Previous</Button>
                    <span className="small mr-2">Page {currentPage} of {totalPages}</span>
                    <Button size="sm" variant="outline-primary" className="mr-1" disabled={currentPage === totalPages} onClick={() => setPage(currentPage + 1)}>Next</Button>
                    <Button size="sm" variant="outline-primary" disabled={currentPage === totalPages} onClick={() => setPage(totalPages)}>Last</Button>
                  </div>
                </nav>}
            </div>
          </div>
        </div>
      </div>
      <div>
        {" "}
        <Modal show={showCreateModal} onHide={handleClose} size="lg" scrollable centered className="incoming-patient-modal">
          <Modal.Header closeButton>
            <Modal.Title>Incoming Patient</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form key={showCreateModal ? "open" : "closed"} id="incoming-create-form" onSubmit={submitHandler}>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group controlId="formFirstName">
                    <Form.Label>*สถานะ</Form.Label>
                    <select
                      className="form-control"
                      name="status"
                      value={createStatus}
                      onChange={handleInputChange}
                      required={true}
                    >
                      <option value="">กดเพื่อเลือก</option>
                      {statusList.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formGender">
                    <Form.Label>*Node</Form.Label>
                    <select
                      className="form-control"
                      name="nodeRef"
                      disabled={saving}
                      defaultValue={profileRef.current["nodeRef"]}
                      onChange={async (e) => await onChangeNode(e.target.value)}
                      required={true}
                    >
                      <option value="">กดเพื่อเลือก</option>
                      {nodesList.map((item, index) => (
                        <option key={index} value={item.nodename}>
                          {item.nodename}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group controlId="formGender">
                    <Form.Label>*Customer</Form.Label>
                    <select
                      className="form-control"
                      name="refCustomer"
                      disabled={saving}
                      key={profileRef.current["nodeRef"]}
                      defaultValue={profileRef.current["refCustomer"]}
                      onChange={handleInputChange}
                      required={true}
                    >
                      <option value="">กดเพื่อเลือก</option>
                      {customers.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formFirstName">
                    <Form.Label>*คำนำหน้า</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก คำนำหน้า"
                      name="titleTh"
                      defaultValue={profileRef.current["titleTh"]}
                      onChange={handleInputChange}
                      required={true}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="formFirstName">
                    <Form.Label>เลขบัตรประจำตัวประชาชน</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก เลขบัตรประจำตัวประชาชน"
                      name="nationalId"
                      defaultValue={profileRef.current["nationalId"]}
                      onChange={handleInputChange}
                      required={false}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formFirstName">
                    <Form.Label>*ชื่อ</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก ชื่อ"
                      name="firstnameTh"
                      defaultValue={profileRef.current["firstnameTh"]}
                      onChange={handleInputChange}
                      required={true}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="formLastName">
                    <Form.Label>*นามสกุล</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก นามสกุล"
                      name="lastnameTh"
                      defaultValue={profileRef.current["lastnameTh"]}
                      onChange={handleInputChange}
                      required={true}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formHN">
                    <Form.Label>*รหัสโรงพยาบาลอ้างอิง</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก รหัสโรงพยาบาลอ้างอิง"
                      name="refHn"
                      defaultValue={profileRef.current["refHn"]}
                      onChange={handleInputChange}
                      required={true}
                    />
                    <small>{"*ไม่ต้องใส่ HN ใส่เฉพาะตัวเลข"}</small>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="formGender">
                    <Form.Label>*เพศ</Form.Label>
                    <select
                      className="form-control"
                      name="gender"
                      defaultValue={profileRef.current["gender"]}
                      onChange={handleInputChange}
                      required={true}
                    >
                      <option value="">กดเพื่อเลือก</option>
                      <option value="ชาย">ชาย</option>
                      <option value="หญิง">หญิง</option>
                    </select>
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formDOB">
                    <Form.Label>*วันเดือนปีเกิด</Form.Label>
                    <IncomingBirthDateInput
                      className="form-control"
                      name="dateOfBirth"
                      defaultValue={profileRef.current["dateOfBirth"]}
                      onChange={handleInputChange}
                      required={true}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="formPhone">
                    <Form.Label>*เบอร์ติดต่อ</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก เบอร์ติดต่อ"
                      name="mobile"
                      defaultValue={profileRef.current["mobile"]}
                      onChange={handleInputChange}
                      required={true}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formDOB">
                    <Form.Label>*สิทธิการเบิก</Form.Label>
                    <select
                      className="form-control"
                      name="healthInsurance"
                      defaultValue={profileRef.current["healthInsurance"]}
                      onChange={handleInputChange}
                      required={true}
                    >
                      <option value="">กดเพื่อเลือก</option>
                      {paymentPrivilages.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group controlId="formPhone">
                    <Form.Label>สิทธิการเบิกอื่นๆ</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก สิทธิ์การเบิกอื่นๆ"
                      name="other"
                      defaultValue={profileRef.current["other"]}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formDOB">
                    <Form.Label>ที่อยู่</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก ที่อยู่"
                      name="address1"
                      defaultValue={profileRef.current["address1"]}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group controlId="formPhone">
                    <Form.Label>ที่อยู่ (ต่อ)</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก ที่อยู่ (ต่อ)"
                      name="address2"
                      defaultValue={profileRef.current["address2"]}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <Form.Group controlId="formDOB">
                    <Form.Label>จังหวัด</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก จังหวัด"
                      name="province"
                      defaultValue={profileRef.current["province"]}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="formDOB">
                    <Form.Label>ประวัติการแพ้ยา</Form.Label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="กรอก ประวัติการแพ้ยา"
                      name="medicineIntolerance"
                      defaultValue={profileRef.current["medicineIntolerance"]}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-12">
                  <Form.Group controlId="formPhone">
                    <Form.Label>ข้อความ (Note)</Form.Label>
                    <input
                      className="form-control"
                      as="textarea"
                      placeholder=""
                      name="note"
                      rows={3}
                      defaultValue={profileRef.current["note"]}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className={getIncomingBookingPolicy(createBookingScope.customer) ? "col-12" : "col-md-6"}>
                  <Form.Group controlId="incoming-create-sleep-study-date">
                    <Form.Label>วันที่นัดตรวจการนอนหลับ <span className="text-muted">(ไม่บังคับ)</span></Form.Label>
                    <IncomingStudyDateInput
                      ref={createStudyDateRef}
                      disabled={saving}
                      nodeId={(nodesList.find((node) => node.nodename === createBookingScope.node) || {}).id}
                      customer={createBookingScope.customer}
                      id="incoming-create-sleep-study-date"
                      className="form-control"
                      name="sleepStudyDate"
                      defaultValue={profileRef.current["sleepStudyDate"]}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <IncomingComorbidityField
                    id="incoming-create-comorbidity"
                    defaultValue={profileRef.current.comorbidity}
                    onChange={(value) => { profileRef.current.comorbidity = value; }}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Detail</label>
                    <textarea className="form-control" rows="2" value={detail} onChange={(e) => setDetail(e.target.value)} />
                  </div>
                </div>
                <div className="col-12 incoming-attachments-section">
                  <IncomingFileUpload id="incoming-create-files" files={selectedFiles} disabled={saving}
                    onChange={onFilesChange} onRemove={removeFile}
                    onPreview={(file) => { previewSelectedFile(file); setShowModalImage(true); }} />
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose} disabled={saving}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" form="incoming-create-form" disabled={saving}>
              Save Patient
            </Button>
          </Modal.Footer>
        </Modal>
        {selectedPatient && (
          <Modal show={showEditModal} onHide={handleEditModalClose} size="lg" scrollable centered className="incoming-patient-modal">
            <Modal.Header closeButton>
              <div className="incoming-modal-identity">
                <Modal.Title>Edit Patient</Modal.Title>
                <div className="incoming-modal-subtitle">{[selectedPatient.firstnameTh, selectedPatient.lastnameTh].filter(Boolean).join(" ")}{selectedPatient.hn && ` · HN ${selectedPatient.hn}`}</div>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Form id="incoming-edit-form" onSubmit={(e) => submitEditHandler(e, selectedPatient)}>
                <fieldset disabled={saving}>
                {/* Reuse your existing form fields but populate with selectedPatient */}
                <div className="row">
                  {(isSuperAdmin || selectedPatient.hn) && <div className="col-12">
                    <Form.Group controlId="incoming-company-hn">
                      <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                        <Form.Label className="mb-0 mr-2">Company HN</Form.Label>
                        <span className={`badge ${selectedPatient.hn ? "badge-success" : "badge-light"}`}>
                          {selectedPatient.hn ? "Patient Created" : "Not Created"}
                        </span>
                      </div>
                      <input
                        id="incoming-company-hn"
                        className="form-control"
                        type="text"
                        placeholder="Enter Company HN manually"
                        name="hn"
                        value={companyHn}
                        onChange={(e) => setCompanyHn(e.target.value)}
                        disabled={!isSuperAdmin || !editingHn || saving}
                      />
                      {isSuperAdmin && (
                        <div className="form-row mt-2">
                          <div className="col-12 col-sm-6 mb-2">
                            {!editingHn ? (
                              <Button size="sm" variant="outline-primary" className="w-100 py-2" type="button" disabled={saving} onClick={() => setEditingHn(true)}>Edit Company HN</Button>
                            ) : (
                              <Button size="sm" variant="outline-secondary" className="w-100 py-2" type="button" disabled={saving} onClick={() => { setCompanyHn(selectedPatient.hn || ""); setEditingHn(false); }}>Cancel HN Edit</Button>
                            )}
                          </div>
                          <div className="col-12 col-sm-6 mb-2">
                            <Button size="sm" variant="outline-info" className="w-100 py-2" type="button" disabled={saving || fetchingHn} onClick={handleFetchCompanyHn}>
                              {fetchingHn ? "Fetching…" : "Fetch Company HN"}
                            </Button>
                          </div>
                        </div>
                      )}
                      {isSuperAdmin && hnMatches !== null && (
                        <div className="border-top pt-3 mt-1" aria-live="polite">
                          {!hnMatches.length ? <div className="small text-muted">No patient found with the same full name.</div> : (
                            <>
                              <div className="small mb-1">{hnMatches.length} matching patient(s). Check the details before linking.</div>
                              <ul className="list-unstyled mb-2" style={{ maxHeight: "220px", overflowY: "auto" }}>
                                {hnMatches.map((match) => (
                                  <li key={match.hn} className="border-bottom py-2">
                                    <label className="d-flex align-items-start mb-0" htmlFor={`incoming-hn-match-${match.hn}`}>
                                      {!selectedPatient.hn && <input id={`incoming-hn-match-${match.hn}`} className="mr-2 mt-1" type="radio" name="matchedCompanyHn" value={match.hn} checked={selectedMatchHn === match.hn} onChange={() => setSelectedMatchHn(match.hn)} disabled={saving} />}
                                      <span>
                                        <strong>{match.hn}</strong> · {[match.firstnameTh, match.lastnameTh].filter(Boolean).join(" ") || [match.firstnameEn, match.lastnameEn].filter(Boolean).join(" ")}
                                        <span className="d-block small text-muted">Date of birth: {formatIncomingDate(match.dateOfBirth) || "—"} · Node: {match.nodeRef || "—"} · Customer: {match.refCustomer || "—"}</span>
                                      </span>
                                    </label>
                                  </li>
                                ))}
                              </ul>
                              {selectedPatient.hn ? <div className="small text-muted">This incoming record already has Company HN {selectedPatient.hn}.</div> : (
                                <Button size="sm" variant="success" type="button" disabled={saving || !selectedMatchHn} onClick={handleLinkPatient}>Link Selected Patient</Button>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </Form.Group>
                  </div>}
                  <div className="col-md-6">
                    <Form.Group controlId="formFirstName">
                      <Form.Label>*สถานะ</Form.Label>
                      <select
                        className="form-control"
                        name="status"
                        value={selectedPatient.status || ""}
                        onChange={handleInputChangeEdit}
                        required={true}
                      >
                        <option value="">กดเพื่อเลือก</option>
                        {statusList.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formGender">
                      <Form.Label>*Node</Form.Label>
                      <select
                        className="form-control"
                        defaultValue={selectedPatient["nodeRef"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                        disabled
                      >
                        <option value="">กดเพื่อเลือก</option>
                        {nodesList.map((item, index) => (
                          <option key={index} value={item.nodename}>
                            {item.nodename}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group controlId="formGender">
                      <Form.Label>*Customer</Form.Label>
                      <select
                        className="form-control"
                        name="refCustomer"
                        defaultValue={selectedPatient["refCustomer"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                        disabled
                      >
                        <option value="">กดเพื่อเลือก</option>
                        {customers.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formFirstName">
                      <Form.Label>*คำนำหน้า</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก คำนำหน้า"
                        name="titleTh"
                        defaultValue={selectedPatient["titleTh"]}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group controlId="formFirstName">
                      <Form.Label>เลขบัตรประจำตัวประชาชน</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก เลขบัตรประจำตัวประชาชน"
                        name="nationalId"
                        defaultValue={selectedPatient["nationalId"]}
                        onChange={handleInputChangeEdit}
                        required={false}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formFirstName">
                      <Form.Label>*ชื่อ</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก ชื่อ"
                        name="firstnameTh"
                        defaultValue={selectedPatient["firstnameTh"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group controlId="formLastName">
                      <Form.Label>*นามสกุล</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก นามสกุล"
                        name="lastnameTh"
                        defaultValue={selectedPatient["lastnameTh"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formHN">
                      <Form.Label>*รหัสโรงพยาบาลอ้างอิง</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก รหัสโรงพยาบาลอ้างอิง"
                        name="refHn"
                        defaultValue={selectedPatient["refHn"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                      />
                      <small>{"*ไม่ต้องใส่ HN ใส่เฉพาะตัวเลข"}</small>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group controlId="formGender">
                      <Form.Label>*เพศ</Form.Label>
                      <select
                        className="form-control"
                        name="gender"
                        defaultValue={selectedPatient["gender"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                      >
                        <option value="">กดเพื่อเลือก</option>
                        <option value="ชาย">ชาย</option>
                        <option value="หญิง">หญิง</option>
                      </select>
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formDOB">
                      <Form.Label>*วันเดือนปีเกิด</Form.Label>
                      <IncomingBirthDateInput
                        className="form-control"
                        name="dateOfBirth"
                        defaultValue={selectedPatient["dateOfBirth"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group controlId="formPhone">
                      <Form.Label>*เบอร์ติดต่อ</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก เบอร์ติดต่อ"
                        name="mobile"
                        defaultValue={selectedPatient["mobile"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formDOB">
                      <Form.Label>*สิทธิการเบิก</Form.Label>
                      <select
                        className="form-control"
                        name="healthInsurance"
                        defaultValue={selectedPatient["healthInsurance"]}
                        onChange={handleInputChangeEdit}
                        required={true}
                      >
                        <option value="">กดเพื่อเลือก</option>
                        {paymentPrivilages.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group controlId="formPhone">
                      <Form.Label>สิทธิการเบิกอื่นๆ</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก สิทธิ์การเบิกอื่นๆ"
                        name="other"
                        defaultValue={selectedPatient["other"]}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formDOB">
                      <Form.Label>ที่อยู่</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก ที่อยู่"
                        name="address1"
                        defaultValue={selectedPatient["address1"]}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group controlId="formPhone">
                      <Form.Label>ที่อยู่ (ต่อ)</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก ที่อยู่ (ต่อ)"
                        name="address2"
                        defaultValue={selectedPatient["address2"]}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <Form.Group controlId="formDOB">
                      <Form.Label>จังหวัด</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก จังหวัด"
                        name="province"
                        defaultValue={selectedPatient["province"]}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group controlId="formDOB">
                      <Form.Label>ประวัติการแพ้ยา</Form.Label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="กรอก ประวัติการแพ้ยา"
                        name="medicineIntolerance"
                        defaultValue={selectedPatient["medicineIntolerance"]}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-12">
                    <Form.Group controlId="formPhone">
                      <Form.Label>ข้อความ (Note)</Form.Label>
                      <input
                        className="form-control"
                        as="textarea"
                        placeholder=""
                        name="note"
                        rows={3}
                        defaultValue={selectedPatient["note"]}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className={getIncomingBookingPolicy(selectedPatient.refCustomer) ? "col-12" : "col-md-6"}>
                    <Form.Group controlId="incoming-edit-sleep-study-date">
                      <Form.Label>วันที่นัดตรวจการนอนหลับ <span className="text-muted">(ไม่บังคับ)</span></Form.Label>
                      <IncomingStudyDateInput
                        ref={editStudyDateRef}
                        bookingLink={selectedPatient.incomingBooking}
                        disabled={saving}
                        nodeId={(nodesList.find((node) => node.nodename === selectedPatient.nodeRef) || {}).id}
                        customer={selectedPatient.refCustomer}
                        id="incoming-edit-sleep-study-date"
                        className="form-control"
                        name="sleepStudyDate"
                        defaultValue={selectedPatient["sleepStudyDate"] || ""}
                        onChange={handleInputChangeEdit}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <IncomingComorbidityField
                      id="incoming-edit-comorbidity"
                      defaultValue={selectedPatient.comorbidity}
                      onChange={(value) => setSelectedPatient((prev) => ({ ...prev, comorbidity: value }))}
                    />
                  </div>
                </div>

                <div className="incoming-attachments-section mt-3">
                  <IncomingFileUpload id="incoming-edit-files" files={selectedFiles} disabled={saving}
                    onChange={onFilesChange} onRemove={removeFile}
                    onPreview={(file) => { previewSelectedFile(file); setShowModalImage(true); }}
                    notes={notesList} urls={noteImageURLs} onPreviewSaved={previewSavedFile} loadingPreviews={loadingFilePreviews}
                    canRemoveSaved={deleteAllowed.some((role) => (currentUser.roles || []).includes(role))}
                    onRemoveSaved={onRemoveIncomingFile} onUpload={handleUploadIncomingFiles} />
                </div>

                {/* Include all other form fields similarly */}
                </fieldset>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" disabled={saving} onClick={handleEditModalClose}>
                Cancel
              </Button>
              {isSuperAdmin && selectedPatient.patientHnChange && selectedPatient.patientHnChange.authPending ? (
                <Button variant="success" type="button" disabled={saving} onClick={handleRegisterPatient}>Finish HN Change</Button>
              ) : isSuperAdmin && (!selectedPatient.hn || editingHn) && (
                <Button variant="success" type="button" disabled={saving || !editingHn || !companyHn.trim() || companyHn.trim() === selectedPatient.hn} onClick={handleRegisterPatient}>
                  {saving ? "Saving…" : selectedPatient.hn ? "Save Company HN" : "Create Patient"}
                </Button>
              )}
              <Button
                variant="primary"
                type="submit"
                form="incoming-edit-form"
                disabled={saving || (editingHn && companyHn.trim() !== (selectedPatient.hn || ""))}
              >
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <Modal show={showModalImage} onHide={() => setShowModalImage(false)} size="xl" centered className="incoming-preview-modal">
          <Modal.Header>
            <Modal.Title title={previewFileName}>{previewFileName || "File preview"}</Modal.Title>
            <button type="button" className="close" aria-label="Close preview" onClick={() => setShowModalImage(false)}><span aria-hidden="true">&times;</span></button>
          </Modal.Header>
          <Modal.Body>
            {showModalImage && <IncomingFilePreview key={previewImage} url={previewImage} filename={previewFileName} type={previewFileType} />}
          </Modal.Body>
        </Modal>
      </div>
    </Fragment>
  );
};
export default Incoming;
